module.exports = __webpack_public_path__ + "static/media/naqeeb.7d8b7f06.jpg";